import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import mapPin from '../../images/common/check.svg';
import locationSetting from '../../images/common/setting.svg';
import trash from '../../images/common/delete.svg';

const DeviceListMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Button = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 5px;
  border-width: 0px;
  margin: 5px 5px;
  color: #333;
  background-color: #eee;
  display: block;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
    background: #000;
    color: #fff;
  }
  border: px solid #f00;
`;
const ButtonContents = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DefaultDevice = styled.div`
  width: 30px;
  margin: 5px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const DeviceManagerTitle = styled.div`
  width: 100%;
  background-color: #43528a;
  padding: 10px;
  height: 40px;
  text-align: left;
`;
const Device = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid #202232;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
`;
const ButtonBox = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;
const DeviceName = styled.div`
  flex: 1 1 0%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const DeviceListContents = styled.div`
  display: ${props => (props.displayDeviceList ? 'block' : 'none')};
`;
const ToolIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
    background: #000;
    color: #fff;
  }
`;
const ToolIconImg = styled(ToolIcon)`
  width: 25px;
  height: 25px;
`;

const DeviceList = ({
  userDevices,
  displayDeviceList,
  toggleDeviceList,
  onSendLocation,
  onDelete,
}) => (
  <DeviceListMain className="DeviceList">
    <DeviceManagerTitle
      id="toggleDeviceList"
      onClick={() => toggleDeviceList()}
    >
      <FormattedMessage id="timeLine.deviceList.sp.title" />
    </DeviceManagerTitle>
    <DeviceListContents displayDeviceList={displayDeviceList}>
      {userDevices &&
        userDevices.map(device => {
          const { deviceId, deviceNickname, locationInfoOnOff } = device;
          return (
            <Device key={`device${deviceId}`}>
              <DeviceName>{deviceNickname}</DeviceName>
              <ButtonBox>
                {(locationInfoOnOff && (
                  <DefaultDevice>
                    <ToolIconImg src={mapPin} alt="map-pin" />
                  </DefaultDevice>
                )) || (
                  <Button
                    id={`sendLocationButton${deviceId}`}
                    onClick={() => onSendLocation(deviceId)}
                  >
                    <ButtonContents>
                      <ToolIcon
                        id="setLocation"
                        src={locationSetting}
                        alt="location-arrow"
                      />
                    </ButtonContents>
                  </Button>
                )}
                <Button
                  id={`deleteDeviceButton${deviceId}`}
                  onClick={() => onDelete(deviceId)}
                >
                  <ButtonContents>
                    <ToolIcon id="releaseDevice" src={trash} alt="trash" />
                  </ButtonContents>
                </Button>
              </ButtonBox>
            </Device>
          );
        })}
    </DeviceListContents>
  </DeviceListMain>
);

DeviceList.propTypes = {
  userDevices: PropTypes.array.isRequired,
  displayDeviceList: PropTypes.bool.isRequired,
  toggleDeviceList: PropTypes.func.isRequired,
  onSendLocation: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeviceList;
